import { createUseStyles } from 'react-jss';
import {
  cssFontSizeMedium,
  cssColorDark,
  cssSpacingMd,
} from '../constants/globalcss';
import { CSSProperties } from 'react';

const useStyles = createUseStyles({
  label: {
    alignItems: 'center',
    display: 'flex',
    fontSize: cssFontSizeMedium,
    fontWeight: 600,
    justifyContent: 'flex-start',
    paddingBlock: cssSpacingMd,
    position: 'relative',
    textAlign: 'left',
    width: '100%',
    wordBreak: 'break-word',
  },

  required: {
    color: 'red',
    fontSize: '16px',
    marginTop: '8px',
  },
  // Border style
  withBorder: {
    '&::after': {
      backgroundColor: cssColorDark,
      bottom: 0,
      content: '""',
      height: '3px',
      left: 0,
      position: 'absolute',
      width: '100%',
    },
  },
});

export interface ILabelProps {
  text: string;
  required?: boolean;
  htmlFor?: string;
  width?: string | number;
  style?: CSSProperties;
  noBorder?: boolean;
}

function LabelNoHover(props: ILabelProps) {
  const classes = useStyles();
  const style = {
    ...(props.width ? { width: props.width } : {}),
    ...(props.style || {}),
  };

  const labelClassName = `${classes.label} ${props.noBorder ? '' : classes.withBorder}`;

  return (
    <label className={labelClassName} htmlFor={props.htmlFor} style={style}>
      {props.text}
      {props.required && <span className={classes.required}>&nbsp;*</span>}
    </label>
  );
}

export default LabelNoHover;
